import React, { forwardRef, useState } from 'react'
import PropTypes from 'prop-types'

import S from './Label.styled'

const Label = forwardRef(
  (
    {
      children,
      label,
      value,
      className = '',
      labelClassName = '',
      onChange,
      onFocus = () => {},
      onBlur = () => {},
      onKeyDown = () => {},
      isError = false,
      isDisabled = false,
      isReadOnly = false,
      isResetFocused = false,
      accentColor,
    },
    ref
  ) => {
    const [isFocus, setIsFocus] = useState(false)

    const onInputChange = (e) => {
      onChange(e)
    }

    const onInputFocus = (e) => {
      onFocus(e)
      setIsFocus(true)
    }

    const onInputBlur = (e) => {
      onBlur(e)
      setIsFocus(false)
    }

    const onInputKeyDown = (e) => {
      onKeyDown(e)
    }

    return (
      <S.Label
        ref={ref}
        className={className}
        isError={isError}
        isFocus={isFocus}
        isFilled={value !== ''}
        isDisabled={isDisabled}
        isReadOnly={isReadOnly}
        isResetFocused={isResetFocused}
        accentColor={accentColor}
      >
        <label className={`label-content ${labelClassName}`}>
          <div className="label-text-wrapper">
            <span className="label-text">{label}</span>
          </div>
          {children({
            onChange: onInputChange,
            onFocus: onInputFocus,
            onBlur: onInputBlur,
            onKeyDown: onInputKeyDown,
          })}
        </label>
      </S.Label>
    )
  }
)

Label.propTypes = {
  children: PropTypes.func.isRequired,
  label: PropTypes.node,
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  isError: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isResetFocused: PropTypes.bool,
  accentColor: PropTypes.string,
}

export default Label
